import { Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface AppleUser {
  id: string;
  name: string;
  email: string;
}

@Injectable({ providedIn: 'root' })
export class AppleAuthService {
  readonly isAuthenticated$: Observable<boolean> = of(false);
  readonly isAuthenticated = false;

  getCurrentUser(): AppleUser | null {
    return null;
  }

  signInWithRedirect(): void {
    console.warn('AppleAuthService: signInWithRedirect not implemented');
  }

  signOut(): void {
    console.warn('AppleAuthService: signOut not implemented');
  }
}
